import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { CommonMethodService } from '../../common/commonMethod.service';
import { BookedGuestRegisterModel } from '../../models/bookedGuest.model';
import { GuestService } from '../../services/guest.service';
import { DatePipe } from '@angular/common';
import { AdministratorService } from '../../services/administrator.service';
import { FeatureList } from '../../models/accountConfig.model';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AccountService } from '../../services/account.service';
import { UserService } from '../../services/user.service';
import { PremiseService } from '../../services/premise.service';
import { GadgetsModel } from '../../models/gadgets.model';
import { EmployeeService } from '../../services/employee.service';
import { ResidentService } from '../../services/resident.service';
import { SecondaryGuestModel } from '../../models/secondaryGuest.model';
import { AppUtility } from '../../common/apputility';
import { VwSelectOption } from '../../shared/ui/searchable-select/searchable-select.component';

@Component({
  selector: 'app-add-self-guest',
  templateUrl: 'addSelfGuest.component.html',
  styleUrls: ['addSelfGuest.component.css'],
  providers: [CommonMethodService, GuestService, DatePipe, PremiseService,
    AdministratorService, AccountService, EmployeeService, ResidentService,
    UserService]
})
export class AddSelfGuestComponent implements OnInit, OnDestroy {

  @ViewChild('primaryModal') public primaryModal: ModalDirective;
  @ViewChild('primaryModal1') public primaryModal1: ModalDirective;
  @ViewChild('primaryModal2') public primaryModal2: ModalDirective;

  visitorForm: FormGroup;
  subscribe: Array<Subscription> = [];
  schoolObject: any;
  dbId: any;
  userObject: any;
  edit: boolean = false;
  countryList: Array<any> = [];

  // 190+ countries: a type-to-filter dropdown is far easier on a phone than scrolling a native list.
  get dialingCodeOptions(): VwSelectOption[] {
    return this.countryList.map(c => ({ value: c.dialingCode, label: `${c.dialingCode} (${c.countryName})` }));
  }

  get nationalityOptions(): VwSelectOption[] {
    return this.countryList.map(c => ({ value: c.nationality, label: `${c.countryName} (${c.nationality})` }));
  }
  logo: Array<any> = [];
  accountId: number;
  employeeId: number;
  todayDate: string;
  todayDate1: Date;
  dbConfigFeatureList: Array<FeatureList> = [];
  visitorType: string;
  guest: boolean = false;
  show: boolean = false;
  show1: boolean = false;
  vtype: string;
  guestDetail: any;
  loader: boolean = false;
  keyword = 'profileName';
  profileList: Array<any> = [];
  companyList: Array<any> = [];
  companyNameList: Array<any> = [];
  companyAddressList: Array<any> = [];
  contactNo: boolean = true;
  email: boolean = true;
  gender: boolean = true;
  address: boolean = true;
  fromPage: string;
  showCancel: boolean = false;
  upperHierarchyList: Array<any> = [];
  residentList: Array<any> = [];
  tempUpperHierarchyList: Array<any> = [];
  hierarchhyList: Array<any> = [];
  levelName: string;
  gadgetsList: Array<GadgetsModel> = [];
  deviceName: string;
  deviceType: string;
  deviceSerialNo: string;
  deviceManufacturer: string;
  deviceTagNo: string;
  permission: boolean = false;
  residentId: number;
  guestObj: any = {};
  rejectReason: string;
  mode: string;


  //NOW
  guestGroupFeature: boolean = false;
  secFullName: string;
  secDialingCode: string;
  secContactNo: string;
  secDocumentType: string;
  secDocumentId: string;
  secAddress: string;
  minor: boolean = false;
  tempId: number;
  deviceTempId: number;
  secondaryGuestList: Array<SecondaryGuestModel> = [];

  showFullname: boolean = false;
  showDocumentID: boolean = false;
  showContactNo: boolean = false;
  showAddress: boolean = false;
  expectedVehicleModel: string;
  expectedVehicleNo: string;

  //  showNoOfVisitor: boolean = false;
  //  showGuestAddButton: boolean = false;
  showGroupFeature: boolean = false;


  uniqueCode: string;
  // The host fixes the booked date when generating the link. When the link carries one it is shown as
  // plain text (no date control for any browser to enable) and is never taken from the visitor.
  linkDateLocked = false;
  linkExpectedDate: Date | null = null;
  linkLoaded = false;
  linkLoadFailed = false;
  // The host's purpose of visit, shown as plain text like the date (the server applies it regardless).
  linkPurpose: string | null = null;
  linkPurposeLocked = false;

  constructor(private route: Router, private acticeRoute: ActivatedRoute,
    private administratorService: AdministratorService,
    private toaster: ToastrService, private commonMethodService: CommonMethodService, public datepipe: DatePipe
    , private userService: UserService,
  ) {
    this.acticeRoute.params.subscribe(
      params => {
        this.uniqueCode = params['uniqueCode'];
        this.accountId = Number(params['accountId']);
        // this.dbId = params['id'];
        // this.vtype = params['vtype'];
        // this.fromPage = params['from'];
      });
  }

  ngOnInit(): void {
    this.todayDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.todayDate1 = (new Date());
    // this.accountId = (Number)(sessionStorage.getItem('accountId'));
    // this.employeeId = (Number)(sessionStorage.getItem('employeeId'));
    this.visitorForm = new FormGroup({
      fullName: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      documentType: new FormControl(''),
      contactNo: new FormControl(''),
      documentId: new FormControl('', [Validators.maxLength(30)]),
      email: new FormControl('', [Validators.email, Validators.maxLength(50)]),
      address: new FormControl('', [Validators.maxLength(100)]),
      // dob: new FormControl(''),
      expectedDate: new FormControl('', [Validators.required]),
      gender: new FormControl(''),
      // country: new FormControl(''),
      // companyName: new FormControl('', [Validators.maxLength(50)]),
      // companyAddress: new FormControl('', [Validators.maxLength(50)]),
      // profile: new FormControl('', [Validators.maxLength(25)]),
      expectedVehicleNo: new FormControl('', [Validators.pattern('[a-zA-Z0-9 ]*'), Validators.maxLength(20)]),
      expectedVehicleModel: new FormControl('', [Validators.pattern('[a-zA-Z0-9 ]*'), Validators.maxLength(20)]),
      // status: new FormControl(''),
      // visitorType: new FormControl(''),
      // isVip: new FormControl(''),
      image: new FormControl(''),
      dialingCode: new FormControl(''),
      // employment: new FormControl(''),
       purposeOfVisit: new FormControl('', [Validators.required,Validators.maxLength(50)]),
      // premiseHierarchyDetailsId: new FormControl('', [Validators.required]),
      nationality: new FormControl('', [Validators.required]),
      // residentId: new FormControl('', [Validators.required]),
      mode: new FormControl(''),
      // vehicleImage: new FormControl(null),
      // noOfVisitor: new FormControl(null),
      groupType: new FormControl(null),
      // bodyTemperature: new FormControl(null)
    });
    // if (this.dbId !== undefined && this.dbId !== '') {
    //   this.edit = true;
    //   if (this.fromPage !== undefined && this.fromPage !== '') {
    //     this.showCancel = true;
    //   } else {
    //     this.showCancel = false;
    //   }
    // }
    this.checkLinkExpire();
    this.getAccountConfiguration();
    this.getCountryList('');
    // const dialingCode = sessionStorage.getItem('dialingCode');
    // if (dialingCode !== null && dialingCode !== undefined) {
    //   this.visitorForm.get('dialingCode').setValue(dialingCode);
    // }
    this.getFieldConfiguration();
    this.getGuestGroupCfg();
  }

  // selectResident(event): void {
  //   if (event.target.value !== undefined && event.target.value !== null && event.target.value !== '') {
  //     this.subscribe.push(this.residentService.getFamilyMemberByFlatId(this.accountId, event.target.value).subscribe(
  //       data => {
  //         const wrapper  = JSON.parse(JSON.stringify(data));
  //         this.residentList = wrapper;
  //       }, error => {
  //         this.commonMethodService.returnErrorMessage(error);
  //       }));
  //   }
  // }

  getCountryList(search): void {
    this.subscribe.push(this.userService.getCountryList(search).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        this.countryList = wrapper;
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  //SECONDARY GUEST CFG
  getGuestGroupCfg(): void {
    this.subscribe.push(this.administratorService.getGuestGroupCfg(this.accountId).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        this.guestGroupFeature = wrapper.guestGroupFeature;
        let element = wrapper.secGuestField;
        if (this.guestGroupFeature == true) {
          this.showFullname = element.secFullname;
          this.showContactNo = element.secContactNo;
          this.showDocumentID = element.secDocumentID;
          this.showAddress = element.secAddress;
        }
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }


  addSecondaryGuest(): void {
    this.secFullName = null;
    this.secDialingCode = null;
    this.secContactNo = null;
    this.secDocumentType = null;
    this.secDocumentId = null;
    this.secAddress = null;
    this.tempId = null;
    this.minor = false;
    this.primaryModal2.show();
  }

  onSubmitSecGuestInfo(): void {
    const model: SecondaryGuestModel = new SecondaryGuestModel();
    if (this.showFullname === true) {
      if (this.secFullName !== null && this.secFullName !== undefined && this.secFullName.trim() !== '') {
        model.fullName = this.secFullName;
      } else {
        this.toaster.error('Please enter full name');
        return;
      }
    }
    if (this.minor === false) {
      if (this.showContactNo === true) {
        if (this.secDialingCode === null || this.secDialingCode === undefined || this.secDialingCode.trim() === '') {
          this.toaster.error('Please select the dialling code');
          return;
        }
        if (this.secContactNo === null || this.secContactNo === undefined) {
          this.toaster.error('Please enter the contact no');
          return;
        }
        if (this.secContactNo.toString().length < 8 || this.secContactNo.toString().length > 14) {
          this.toaster.error('Contact no must be between 8 to 14 digits');
          return;
        } else if (this.secContactNo.toString().includes('-') || this.secContactNo.toString().includes('.')) {
          this.toaster.error('Invalid contact no');
          return;
        }
        model.dialingCode = this.secDialingCode;
        model.contactNo = this.secContactNo;
      }
      if (this.showDocumentID === true) {
        if (this.secDocumentType === null || this.secDocumentType === undefined) {
          this.toaster.error('Please select the document type');
          return;
        }
        if (this.secDocumentId === null || this.secDocumentId === undefined || this.secDocumentId.trim() === '') {
          this.toaster.error('Please enter the identity no');
          return;
        }
        model.documentType = this.secDocumentType;
        model.documentId = this.secDocumentId;
      }
    }
    if (this.showAddress === true) {
      if (this.secAddress !== null && this.secAddress !== undefined && this.secAddress.trim() !== '') {
        model.address = this.secAddress;
      } else {
        this.toaster.error('Please enter  address');
        return;
      }
    }
    model.minor = this.minor
    if (this.minor === true) {
      model.dialingCode = null;
      model.contactNo = null;
      model.documentType = null;
      model.documentId = null;
    }
    if (this.tempId != null) {
      model.tempId = this.tempId;
      this.secondaryGuestList.splice(this.tempId, 1, model);
    }
    else {
      model.tempId = this.secondaryGuestList.length;
      // Same limit as every other booking form: 10 people in total (the main guest + 9).
      if (model.tempId > 8) {
        this.toaster.error('A group booking is limited to 10 people only');
        return;
      }
      this.secondaryGuestList.push(model);
    }

    this.secFullName = null;
    this.secDialingCode = null;
    this.secContactNo = null;
    this.secDocumentType = null;
    this.secDocumentId = null;
    this.secAddress = null;
    this.tempId = null;
    this.minor = false;
    this.primaryModal2.hide();
  }

  removeSecGuest(tempId): void {
    const tempList = this.secondaryGuestList;
    this.secondaryGuestList = [];
    tempList.forEach(element => {
      if (element.tempId !== tempId) {
        this.secondaryGuestList.push(element);
      }
    });
  }

  editSecGuest(guest) {
    this.secFullName = guest.fullName;
    this.secDocumentType = guest.documentType;
    this.secDocumentId = guest.documentId;
    this.secDialingCode = guest.dialingCode;
    this.secContactNo = guest.contactNo;
    this.secAddress = guest.address;
    this.minor = guest.minor;
    this.tempId = guest.tempId;
    this.primaryModal2.show();
  }

  onChangeGroupType(event): void {
    if (event.target.value === 'Group') {
      this.getGuestGroupCfg();
      this.showGroupFeature = true;
    } else {
      this.showGroupFeature = false;
      this.showFullname = false;
      this.showDocumentID = false;
      this.showContactNo = false;
      this.showAddress = false;
    }
  }

  getFieldConfiguration(): void {
    this.subscribe.push(this.administratorService.getGuestFieldConfiguration(this.accountId).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        wrapper.forEach(element => {
          if (element.fieldName === 'email') {
            this.email = element.fieldValue;
          } 
          if (element.fieldName === 'contactNo') {
            this.contactNo = element.fieldValue;
          }
          if (element.fieldName === 'address') {
            this.address = element.fieldValue;
          }
          if (element.fieldName === 'gender') {
            this.gender = element.fieldValue;
          }
        });
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  checkLinkExpire(): void {
    this.subscribe.push(this.administratorService.checkLinkExpire(this.accountId, this.uniqueCode).subscribe(
      data => {
        // Link is valid, fetch link details
        this.getSelfServiceLinkDetails();
      }, error => {
        this.route.navigate(['/expire']);
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  // The server sends dates like "2026-10-10T06:58:00.000+0000"; some browsers can't parse an
  // offset written without a colon, so normalise it before building a Date.
  private parseServerDate(value: any): Date | null {
    if (!value) {
      return null;
    }
    const text = typeof value === 'string' ? value.replace(/([+-]\d{2})(\d{2})$/, '$1:$2') : value;
    const parsed = new Date(text);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  // Local wall-clock "yyyy-MM-ddTHH:mm", the only shape a datetime-local control understands.
  private toDateTimeLocal(d: Date): string {
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes());
  }

  getSelfServiceLinkDetails(): void {
    this.subscribe.push(this.administratorService.getSelfServiceLinkByCode(this.accountId, this.uniqueCode).subscribe(
      data => {
        const wrapper = JSON.parse(JSON.stringify(data));
        this.linkLoaded = true;
        if (wrapper.purposeOfVisit) {
          this.linkPurpose = wrapper.purposeOfVisit;
          this.linkPurposeLocked = true;
          this.visitorForm.get('purposeOfVisit').setValue(wrapper.purposeOfVisit);
          this.visitorForm.get('purposeOfVisit').disable();
        }
        if (wrapper.expectedDate) {
          const hostDate = this.parseServerDate(wrapper.expectedDate);
          if (hostDate) {
            this.linkExpectedDate = hostDate;
            this.linkDateLocked = true;
            this.visitorForm.get('expectedDate').setValue(this.toDateTimeLocal(hostDate));
            this.visitorForm.get('expectedDate').disable();
          }
        }
      }, error => {
        // The booked date is the host's to set, so without the link's details there is nothing
        // for the visitor to enter: the page says so and submitting is refused.
        this.linkLoadFailed = true;
      }));
  }

  getAccountConfiguration(): void {
    this.subscribe.push(this.administratorService.getAccountConfiguration(this.accountId).subscribe(
      data => {
        this.dbConfigFeatureList = JSON.parse(JSON.stringify(data));
        this.dbConfigFeatureList.forEach(element => {
          if (element.featureId === 2) {
            this.permission = element.value === 'true' ? true : false;
            this.toggleDocumentValidators(this.permission);
          }
        });
      }, error => {
        this.commonMethodService.returnErrorMessage(error);
      }));
  }

  toggleDocumentValidators(enabled: boolean): void {
    const documentTypeControl = this.visitorForm.get('documentType');
    const documentIdControl = this.visitorForm.get('documentId');
    if (enabled) {
      documentTypeControl.setValidators([Validators.required]);
      documentIdControl.setValidators([Validators.required, Validators.maxLength(30)]);
    } else {
      documentTypeControl.clearValidators();
      documentIdControl.clearValidators();
      documentTypeControl.setValue(null);
      documentIdControl.setValue(null);
    }
    documentTypeControl.updateValueAndValidity();
    documentIdControl.updateValueAndValidity();
  }



  openConfirmationForWalkingVisitor(): void {
    const details: BookedGuestRegisterModel = this.visitorForm.getRawValue();
    if (this.visitorForm.invalid) {
      this.visitorForm.markAllAsTouched();
      this.commonMethodService.checkFormValidOrNot(this.visitorForm);
      return;
    }
    if (this.accountId !== null && this.accountId !== undefined) {
      details.accountId = this.accountId;
    }
    if (details.email !== null && details.email !== undefined && details.email.trim() === '') {
      details.email = null;
    }
    details.image = null;

    if (!AppUtility.isEmptyString(details.mode) && details.mode === 'Drive-In') {
      if (AppUtility.isEmptyString(details.expectedVehicleNo)) {
        // Drive-In needs the vehicle number, otherwise the vehicle report has an unidentified vehicle.
        this.toaster.error('Please enter the vehicle no.');
        return;
      }
      if(!AppUtility.isEmptyString(details.expectedVehicleModel)){
        details.expectedVehicleModel;
      }
    } else {
      details.expectedVehicleNo = null;
      details.vehicleImage = null;
      details.expectedVehicleModel = null;
    }


    if (this.contactNo === true) {
      if (details.dialingCode === null || details.dialingCode === undefined || details.dialingCode.toString() === '') {
        this.toaster.error('Please select the dialing code');
        return;
      }
      if (details.contactNo === null || details.contactNo === undefined || details.contactNo.toString() === '') {
        this.toaster.error('Please enter the contact no');
        return;
      }
      if (details.contactNo.toString().length < 8 || details.contactNo.toString().length > 14) {
        this.toaster.error('Contact no must be between 8 to 14 digits');
        return;
      } else if (details.contactNo.toString().includes('-') || details.contactNo.toString().includes('.')) {
        this.toaster.error('Invalid contact no');
        return;
      }
    }
    if (this.gender === true) {
      if (details.gender === null || details.gender === undefined || details.gender === '') {
        this.toaster.error('Please select gender');
        return;
      }
    }
    if (this.uniqueCode && !this.linkLoaded) {
      this.toaster.error('We could not load the booking details for this link. Please reload the page and try again.');
      return;
    }
    // A host-set date is final (the server applies the link's own value regardless); otherwise the visitor's entry.
    details.expectedDate = this.linkDateLocked ? this.linkExpectedDate : new Date(this.visitorForm.value.expectedDate);
    if (this.linkPurposeLocked) {
      details.purposeOfVisit = this.linkPurpose;   // a disabled control isn't part of the form value
    }
    details.status = true;
    details.fromPage = this.fromPage;
    details.dbId = this.dbId;
    if (this.permission === true) {
      if (details.documentType === null || details.documentType === undefined || details.documentType === '') {
        this.toaster.error('Please select the document type');
        return;
      }
      if (details.documentId === null || details.documentId === undefined || details.documentId.trim() === '') {
        this.toaster.error('Please enter the document id');
        return;
      }
    }
    if (!this.linkDateLocked && details.expectedDate <= new Date()) {
      this.toaster.error('Booked date should be greater than current date');
      return;
    }
    details.id = null;
    this.guestObj = details;

    if (this.visitorForm.get('groupType').value == 'Group') {
      if (this.secondaryGuestList === null || this.secondaryGuestList === undefined || this.secondaryGuestList.length === 0) {
        this.toaster.error('Please add the secondary guest details or change the guest type to individual');
        return;
      }
      if (this.secondaryGuestList.length > 9) {
        this.toaster.error('A group booking is limited to 10 people only');
        return;
      }
      details.guestList = this.secondaryGuestList;
    }

    if (this.guestGroupFeature !== null && this.guestGroupFeature !== undefined && this.guestGroupFeature === false) {
      details.guestList = [];
      details.noOfVisitor = null;
      details.groupType = null;
    }



    details.uniqueCode=this.uniqueCode;
    this.loader = true;
    this.subscribe.push(this.administratorService.createSelfGuest(details).subscribe(
      data => {
        this.loader = false;
        this.toaster.success('Self guest registered successfully.');
        this.route.navigate(['/success', data]);
      }, error => {
        this.loader = false;
        this.commonMethodService.returnErrorMessage(error);
      }));

  }

  onChangeMode(event): void {
    if (event.target.value === 'Drive-In') {
      this.mode = 'Drive-In';
    } else {
      this.mode = 'Walk-In';
    }
  }

  setVisitorType(event): void {
    if (event.target.value === 'Guest') {
      this.visitorType = 'guest';
      if (this.guest === true) {
        this.show = true;
      } else {
        this.show = false;
      }
      this.show1 = false;
      this.getFieldConfiguration();
    } else {
      this.visitorType = 'serviceP';
      this.show = true;
      this.show1 = false;
      this.contactNo = true;
      this.email = true;
      this.gender = true;
      this.address = true;
    }
  }

  showDocumentName(value) {
    return AppUtility.showDocumentName(value);
  }

  ngOnDestroy(): void {
    this.subscribe.forEach(destroyExistingValue => {
      destroyExistingValue.unsubscribe();
    });
  }

}
